import React, { ReactNode, type SyntheticEvent } from "react";
import DatePicker from "react-datepicker";
import "./date-picker-styles.scss";

interface DateTimePickerProps {
  onChange: (
    date: Date | null,
    event: SyntheticEvent<any, Event> | undefined
  ) => void;
  filterDate?: (date: Date) => boolean;
  activeDate: Date | null;
  timeIntervals?: number;
  disabled?: boolean;
  dateFormat?: string;
  showTimeSelect?: boolean;
  timeFormat?: string;
  minDate?: Date;
  required?: boolean;
  open?: boolean;
  inline?: boolean;
  minTime?: Date;
  maxTime?: Date;
  customInput?: ReactNode;
  locale?: string;
}

export default function KC_DateTimePicker(props: DateTimePickerProps) {
  return (
    <>
      <DatePicker
        open={props.open}
        required={props.required}
        wrapperClassName="w-100"
        className="w-100"
        onChange={props.onChange}
        filterDate={props.filterDate}
        locale={props.locale ?? "fr"}
        dateFormat={props.dateFormat || "Ppp"}
        selected={props.activeDate}
        showTimeSelect={props.showTimeSelect || false}
        timeIntervals={props.timeIntervals}
        disabled={props.disabled || false}
        minDate={props.minDate || null}
        minTime={props.minTime}
        maxTime={props.maxTime}
        inline={props.inline}
        customInput={props.customInput}
        popperPlacement="top"
      />
    </>
  );
}
